var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleLock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.142578,
    width: 87.714,
    height: 87.714,
    rx: 43.857,
    fill: "#F6F6F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.0833 39.0493C53.0847 37.4792 52.6771 35.9358 51.9008 34.5711C51.1244 33.2063 50.0061 32.0673 48.6558 31.266C47.3056 30.4647 45.7699 30.0289 44.2001 30.0014C42.6302 29.9739 41.0802 30.3556 39.7027 31.1091C38.3252 31.8626 37.1677 32.9618 36.344 34.2985C35.5203 35.6352 35.059 37.1634 35.0053 38.7325C34.9516 40.3017 35.3075 41.8579 36.0379 43.2477C36.7683 44.6376 37.848 45.8133 39.1708 46.6592L36.6901 57.98H51.3932L48.9125 46.6585C50.1908 45.8427 51.243 44.718 51.972 43.3882C52.7009 42.0584 53.0831 40.5658 53.0833 39.0493Z",
    stroke: "#10A37F",
    strokeWidth: 1.29167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleLock);
export default __webpack_public_path__ + "static/media/circleLock.51a9a5555677804b10ec129f7bbfc1fc.svg";
export { ForwardRef as ReactComponent };